import React, { useMemo, useRef } from 'react';

import { useSelector } from 'react-redux';

import { UnidataTable, Modal } from '~/components';
import DetalhePosto from './components/DetalhePosto'

import { recordFiltering } from '~/store/modules/DlgRelPosto/actions'

import { Visibility } from '@material-ui/icons';


export default function DlgRelPosto() {

    const dlgrelposto = useSelector((state) => state.DlgRelPosto)

    const detalhePostoRef = useRef(null)


    const header = useMemo(
        () => [
            {
                id: 'post_cod_posto',
                label: 'Cód.Unidata',
            },
            {
                id: 'post_cod_posto_fca',
                label: 'Cód.Cliente',
            },
            {
                id: 'post_desc',
                label: 'Descrição',
            },
            {
                id: 'post_corredor',
                label: 'Corredor',
            },
            {
                id: 'poes_desc',
                label: 'Estoque',
            },
            {
                id: 'tipo',
                label: 'Tipo',
            },
            {
                id: 'post_st_reg',
                label: 'Ativo',
            },

        ],
        []
    );
    const buttons = useMemo(() => {
        return [
            {
                title: 'Detalhe Atendimento',
                action: (value) => detalhePostoRef.current.handleOpenModal({
                    reference: detalhePostoRef,
                    data: value,
                }),
                icon: <Visibility />,
            }
        ];
    }, [detalhePostoRef]);

    const modalButtons = useMemo(() => [{
        label: 'Fechar',
        color: 'secondary',
        callback: () => detalhePostoRef.current.handleCloseModal()

    }], [detalhePostoRef])

    return (
        <>
            <UnidataTable
                fixed
                title="Informações dos Postos"
                create={false}
                update={false}
                delete={false}
                actions={buttons}
                header={header}
                redux={dlgrelposto}
                read={recordFiltering}
                detach="post_cod_posto"
                keys="post_cod_posto"
            />

            <Modal
                disableBackdropClick
                disableEscapeKeyDown
                ref={detalhePostoRef}
                title="Dados do Posto"
                maxWidth="lg"
                fullScreen={window.innerWidth <= 425}
                component={DetalhePosto}
                actions={modalButtons}
            />

        </>
    )
}